// Vue
import Vue from "vue";
import App from "./App.vue";
import "@assets/compiled-icons/index";

// Filters
import filters from "@filters";

// Libs
import date from "@packages/date";
import moment from "moment";
import VTooltip from "v-tooltip";
import InputFacade from "vue-input-facade";
import Loading from "vue-loading-overlay";
import VueSVGIcon from "vue-svgicon";
import VueMeta from "vue-meta";
import Auth from "./packages/auth";
import VeeValidate from "./packages/vee-validate";
import vuetify, { buildTheme } from "./packages/vuetify";
import {
    resolveWhitelabelKey,
    resolveWhitelabelUrlKey,
} from "@packages/util/whitelabel/whitelabelKey";
import { applyWhitelabelStyle } from "@packages/util/whitelabel/whitelabelStyle";
import { discardAccountWhitelabel } from "@packages/util/whitelabel/whitelabelReset";
import ProviderUtils from "@packages/util/provider/providerUtils";
import { i18n } from "@packages/I18n";

// API
import Api from "./packages/api";
import Http from "./packages/http";
import Loader from "./packages/loader";
import router from "./packages/router";
import store from "./packages/store";

Vue.config.productionTip = false;

Vue.use(InputFacade);

Vue.use(filters);

Vue.use(Http);
Vue.use(Auth);
Vue.use(Api);
Vue.use(Loader);

Vue.use(date);
Vue.use(VeeValidate);
Vue.use(VTooltip, {
    defaultClass: "vue-tooltip-theme",
    defaultBoundariesElement: "viewport",
});
Vue.use(Loading);
Vue.use(VueSVGIcon);
Vue.use(VueMeta);
moment.locale("pt");

function isLegacyBrandContext(key) {
    if (key && ProviderUtils.isValid(key.toLowerCase())) return true;

    if (resolveWhitelabelUrlKey()) return false;

    const provider = store.getters["layout/provider"];

    return !!provider && ProviderUtils.isValid(provider);
}

function loadAccountWhitelabel() {
    const isAuthenticated = !!localStorage.getItem("token");
    const key = resolveWhitelabelKey();
    const isLegacyBrand = isLegacyBrandContext(key);

    if (isAuthenticated) {
        return store.dispatch("accountWhitelabel/load", {
            key: isLegacyBrand ? "" : key,
            isAuthenticated,
        });
    }

    if (isLegacyBrand || !key) return discardAccountWhitelabel();

    return store.dispatch("accountWhitelabel/load", { key, isAuthenticated });
}

store
    .dispatch("layout/setProvider")
    .then(loadAccountWhitelabel)
    .catch(() => {})
    .then(() => {
        let style = null;

        try {
            style = store.getters["accountWhitelabel/style"];

            if (style) applyWhitelabelStyle(style);
        } catch (e) {
            style = null;
        }

        Vue.use(vuetify, buildTheme(style));

        new Vue({
            el: "#app",
            store,
            router,
            i18n,
            render: (h) => h(App),
        });
    });
